export default `
query GetFormattedAddress($address: String!) {
    getFormattedAddress(address: $address) {
        addressComponents {
            city
            country
            county
            neighborhood
            state
            subpremise
            streetName
            streetNumber
            zipCode
            zipCodeSuffix
        }
        coordinates {
            lat
            lng
        }
        formattedAddress
        placeId
    }
}
`;